export const getAuthStorageKey = (brand: string) =>
  `em-booking--${brand}--auth`;
